import { Nullable } from '../../../global/types';
import {
  CancelRequestFunction,
  getAxiosCancelToken,
} from '../../../utils/net/cancel.token';
import { EfficiencyModel } from '../types';
import { request } from '../../../utils/net/request';
import { getEfficiencyModel } from './transforms/getEfficiencyModel';
import { setModelProductUrls } from './transforms/setModelProductUrls';
import { cancellable } from '../../../utils/promise/cancellable';

export const getModel = async (
  url: string,
  cancelRequest?: Nullable<CancelRequestFunction>,
  getProductUrlById?: Nullable<(id: string) => Promise<string>>,
): Promise<EfficiencyModel> => {
  const cancelToken = cancelRequest
    ? getAxiosCancelToken(cancelRequest)
    : undefined;

  const dtoModel = await request({
    url,
    headers: {
      pragma: 'no-cache',
      'Cache-Control': 'no-cache, no-store',
    },
    ...(cancelToken && { cancelToken }),
  });

  const model = getEfficiencyModel(dtoModel);

  const [modelWithUrls, cancelFn] = cancellable(
    setModelProductUrls(model, getProductUrlById),
  );
  if (cancelRequest) {
    cancelRequest(cancelFn);
  }
  return modelWithUrls;
};
